export const campusKeys = {
  all: () => ['campuses'] as const,
  list: () => [...campusKeys.all(), 'list'] as const,
  detail: (id: string) => [...campusKeys.all(), 'detail', id] as const,
}
